import styled from "styled-components";

export const StyledPayoutTabsWrapper = styled.div`
  margin-top: 3.2rem;
`;
export const StyledPayoutTabsPageWrapper = styled.div`
  margin-top: 3.2rem;
`;
